<p-progressspinner
    [strokeWidth]="strokeWidth()"
    [fill]="fill()"
    [animationDuration]="animationDuration()"
    [ariaLabel]="ariaLabel()"
/>
